module.exports = __webpack_public_path__ + "img/MJ.b45db2e8.png";